module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_vm._v("header")]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_vm._v("body")]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("buttons", function() {
    return [_vm._v("buttons")]
  }), _vm._v(" "), _c('b-button', {
    staticClass: "active-item",
    attrs: {
      "size": 'large',
      "variant": 'secondary'
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "window-minimize"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.button.close')))], 1)], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a66b0af"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/foobar/SnippetOrderModal.vue
// module id = 1838
// module chunks = 1